import {
  RECHARGE_PRODUCT_TO_SUBSCRIPTION_ITEM_TYPE,
} from "libs/api/customer/src/lib/types/products";
import { isFreshRecipe, isFreshExtraProduct } from "@api-clients/subscriptions";

import {
  ChargeSubscription,
  ChargeSubscriptionItem,
  RechargeLineItem,
  RechargeOrder,
} from "@/primary-models";

import {
  TOrderLineItemsFilter,
  TOrderLineItemsWithQuantity,
} from "../types/orders.types";

export const transformRechargeOrderToOrderLineItemWithQuantity = (
  order: RechargeOrder & {
    items: RechargeLineItem[];
  },
  filter: TOrderLineItemsFilter,
): TOrderLineItemsWithQuantity | null => {
  if (!order.items.length) {
    return null;
  }

  const lineItems = order.items.reduce((acc, item) => {
    const product = RECHARGE_PRODUCT_TO_SUBSCRIPTION_ITEM_TYPE[item.productTitle];
    if (!product) {
      return acc;
    }
    switch (filter) {
      case "RECIPES":
        if (isFreshRecipe(product)) {
          acc[product] = item.quantity;
        }
        return acc;
      case "EXTRAS":
        if (isFreshExtraProduct(product)) {
          acc[product] = item.quantity;
        }
        return acc;
      case "ALL":
        acc[product] = item.quantity;
        return acc;
      default:
        throw new Error(`Invalid filter: ${filter}`);
    }
  }, {} as TOrderLineItemsWithQuantity);

  if (!Object.keys(lineItems).length) {
    return null;
  }

  return lineItems;
};

export const transformChargeToOrderLineItemsWithQuantity = (
  subscription: ChargeSubscription & { items: ChargeSubscriptionItem[] },
  filter: TOrderLineItemsFilter,
): TOrderLineItemsWithQuantity | null => {
  if (!subscription.items.length) {
    return null;
  }

  return subscription.items.reduce((acc, item) => {
    switch (filter) {
      case "RECIPES":
        if (isFreshRecipe(item.subscriptionItemType)) {
          acc[item.subscriptionItemType] = item.quantity;
        }
        return acc;
      case "EXTRAS":
        if (isFreshExtraProduct(item.subscriptionItemType)) {
          acc[item.subscriptionItemType] = item.quantity;
        }
        return acc;
      case "ALL":
        acc[item.subscriptionItemType] = item.quantity;
        return acc;
      default:
        throw new Error(`Invalid filter: ${filter}`);
    }
  }, {} as TOrderLineItemsWithQuantity);
};
